// @flow

import styled, { css } from 'styled-components';
import { inPixels } from '../commons/media-size';

export const Padding = styled.div`
  padding: ${props => props.size ? props.size * 1.2 : 1.2}em;

  ${props => props.from && css`
    @media (max-width: calc(${inPixels(props.from)}px - 1px)) {
      padding: 0;
    }
  `}

  ${props => props.to && css`
    @media (min-width: ${inPixels(props.to)}px) {
      padding: 0;
    }
  `}
`;
